var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointstosend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_801_396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.7969 8.20324C36.7062 -2.5702 18.9766 -2.3077 8.20312 8.78292C-2.35156 19.6439 -2.35156 36.936 8.20312 47.797C19.2938 58.5704 37.0234 58.3079 47.7969 47.2173C58.3516 36.3564 58.3516 19.0642 47.7969 8.20324ZM43.9031 24.9048L37.5375 31.1064L39.0359 39.8564C39.2437 41.0485 38.4453 42.1861 37.2422 42.3939C36.7609 42.4814 36.2797 42.3939 35.8422 42.1751L28 38.0407L20.1359 42.1751C19.0641 42.7439 17.7297 42.3282 17.1719 41.2454C16.9531 40.8189 16.8656 40.3267 16.9531 39.8564L18.4516 31.1064L12.0859 24.9048C11.2219 24.0626 11.2 22.6626 12.0422 21.7985C12.3812 21.4485 12.8187 21.2298 13.3 21.1532L22.0938 19.8735L26.0203 11.9001C26.5562 10.8173 27.8797 10.3689 28.9625 10.9048C29.3891 11.1235 29.7391 11.4735 29.9578 11.9001L33.8844 19.8626L42.6781 21.1423C43.8813 21.3173 44.7125 22.4329 44.5375 23.636C44.4828 24.1173 44.2531 24.5657 43.9031 24.9048Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_801_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointstosend);
export default __webpack_public_path__ + "static/media/pointstosend.49d6d9c2241b6e27473d4000d6140321.svg";
export { ForwardRef as ReactComponent };